import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Ofertas especiales',
  view_more: 'Ver más',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Oferta',
    'FREE ITEM': 'Artículo gratis',
    REWARDS: 'Rewards',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Puntos extra',
      description: 'Valóranos en Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Oferta especial',
      description: 'Ya aplicada automáticamente',
    },
    buttons: {
      add: 'Añadir',
      remove: 'Eliminar',
      show_details: 'Ver detalles',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} Bono de registro en la app',
      desc: 'Obtén {{amount}} de cashback al iniciar sesión en nuestra app.',
    },
    welcome_bonus: {
      title: '{{amount}} Bono de bienvenida',
      desc: 'Obtén {{amount}} de cashback al registrarte.',
    },
  },
  discounts: {
    title: '{{discount}} de descuento',
    usage_threshold: '(Mín.: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} de descuento en tu próximo pedido - código: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} de descuento en tus próximos {{count}} pedidos - código: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Inicia sesión</highlight> para usar este promo y asegurarnos de que no lo hayas usado antes. Inicia sesión e inténtalo de nuevo.',
  },
};
